import { EMAIL_VERIFY_BANNER_DISMISSED_STORAGE_KEY } from 'src/utils/constants/common.js'

/**
 * Check if key exists in local storage
 * @param  string key
 * @return boolean
 */
export const localStorageHas = (key) => {
  const item = localStorage.getItem(key)
  return (item !== null)
}

/**
 * Retrive an object from local storage.
 * @param  string key
 * @return mixed
 */
export const localStorageGet = (key) => {
  const item = localStorage.getItem(key)

  if (!item) return

  if (item[0] === '{' || item[0] === '[') return JSON.parse(item)

  return item
}

/**
 * Login persists `emailVerified` as the string 'true' or 'false'.
 * If the key is missing (sessions from before this was stored), treat as verified
 * so legacy users are not blocked; new logins always set the key from the API.
 */
export const getEmailVerifiedFromLocalStorage = () => {
  const raw = localStorage.getItem('emailVerified');
  if (raw === null) return true;
  return raw === 'true';
};

/**
 * Persists fields from GET /profile (or equivalent) into localStorage.
 * Kept in sync with auth login and profile store `get` action.
 */
export const persistLocalStorageFromProfileResponse = (p) => {
  if (!p) return;
  if (p.emailVerified !== undefined) {
    const ev = p.emailVerified === true;
    window.localStorage.setItem('emailVerified', String(ev));
    if (!ev) {
      window.localStorage.setItem(EMAIL_VERIFY_BANNER_DISMISSED_STORAGE_KEY, false);
    }
  }
  if (p.gracePeriodExpired !== undefined || p.emailVerified !== undefined) {
    const emailVerified = p.emailVerified === true;
    const g = emailVerified ? false : !!p.gracePeriodExpired;
    window.localStorage.setItem('gracePeriodExpired', String(g));
  }
  if (p.gracePeriodExpiresAt != null && p.gracePeriodExpiresAt !== '') {
    window.localStorage.setItem('gracePeriodExpiresAt', p.gracePeriodExpiresAt);
  } else {
    window.localStorage.removeItem('gracePeriodExpiresAt');
  }
}
